import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EvaluationStatusForm from '../../../components/forms/EvaluationStatusForm';
import { useEvaluationStatusApi } from '../../../hooks/useEvaluationStatusApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { EvaluationStatusDTO } from '../../../services/apiClient';

const EvaluationStatusCreate: React.FC = () => {
  const { create, isLoading } = useEvaluationStatusApi();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Evaluation Statuses', href: '/admin/evaluationstatuses' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: EvaluationStatusDTO) => {
    try {
      await create(data);
      navigate('/admin/evaluationstatuses');
    } catch (error) {
      console.error('Error creating EvaluationStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/evaluationstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.EvaluationStatus.Edit"
    >
        <EvaluationStatusForm
          initialValues={{} as EvaluationStatusDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/evaluationstatuses')}
        />
    </AdminLayout>
  );
};

export default EvaluationStatusCreate;
